module.exports = __webpack_public_path__ + "img/products_big_can_apricot.7f48df11.png";